import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

import { ISpiralLayout } from '../spiral-calculate-layout/calculate-layout';

export function generateSteps(layout: ISpiralLayout, config: IStairConfig): IStepGeometry[] {
    const steps: IStepGeometry[] = [];
    const { stepCount, riserHeight, outerRadius, innerRadius, anglePerStepRad } = layout;

    const cx: number = outerRadius;
    const cz: number = outerRadius;

    const innerDepth: number = Math.round(2 * innerRadius * Math.sin(anglePerStepRad / 2));

    const clockwise: boolean = config.turnDirection === 'right';
    // The inner edge is a straight chord: placing its ends at innerRadius / cos(half step) makes
    // it touch the pole at its middle instead of cutting into it.
    const innerCornerR: number = innerRadius / Math.cos(anglePerStepRad / 2);
    const dirSign: number = clockwise ? 1 : -1;

    // All visible treads (stepCount - 1)
    for (let i: number = 0; i < stepCount - 1; i++) {
        const startAngle: number = i * anglePerStepRad * dirSign;
        const endAngle: number = (i + 1) * anglePerStepRad * dirSign;
        const midAngle: number = (i + 0.5) * anglePerStepRad * dirSign;
        const y: number = (i + 1) * riserHeight;
        const outerDepth: number = Math.round(2 * outerRadius * Math.sin(anglePerStepRad / 2));
        const treadW: number = outerRadius - innerRadius;
        steps.push({
            index: i,
            position: {
                y,
                x: cx + ((innerRadius + outerRadius) / 2) * Math.sin(midAngle) - treadW / 2,
                z: cx + ((innerRadius + outerRadius) / 2) * Math.cos(midAngle) - outerDepth / 2,
            },
            treadWidth: treadW,
            treadDepth: outerDepth,
            treadThickness: config.treadThickness,
            noseLength: config.noseLength,
            rotation: -(midAngle * 180) / Math.PI,
            isWinder: true,
            isLanding: false,
            winderCorners: {
                innerBack: { x: cx + innerCornerR * Math.sin(startAngle), z: cz + innerCornerR * Math.cos(startAngle) },
                innerFront: { x: cx + innerCornerR * Math.sin(endAngle), z: cz + innerCornerR * Math.cos(endAngle) },
                outerBack: { x: cx + outerRadius * Math.sin(startAngle), z: cz + outerRadius * Math.cos(startAngle) },
                outerFront: { x: cx + outerRadius * Math.sin(endAngle), z: cz + outerRadius * Math.cos(endAngle) },
            },
            riserHeight,
            innerDepth,
            outerDepth,
        });
    }

    return steps;
}
